import { useRef, useEffect } from 'react';
import ChatMessage from './ChatMessage';
import { Message } from 'types/chat';

const Messages = ({ messages, isTyping, isOpen }) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (isOpen) {
      scrollToBottom();
    }
  }, [messages, isOpen]);

  return (
    <div className="flex-grow-1 p-3 overflow-auto">
      {messages.map((message: Message) => (
        <ChatMessage key={message.key} message={message} isUser={message.sender == 'user'} />
      ))}

      {/* Typing indicator */}
      {isTyping && (
        <img alt="loading" width="50" src='/images/commons/gif/typing-texting.gif' />
      )}

      <div ref={messagesEndRef} />
    </div>
  )
};

export default Messages;
